var _style, _path, _path2, _path3, _circle, _circle2, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhysicalCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 631",
    style: {
      enableBackground: "new 0 0 1000 631"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434189;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:7;}\n\t.st3{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st4{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,35.2C0,15.8,15.8,0,35.2,0h929.6c19.4,0,35.2,15.8,35.2,35.2v560.2c0,19.4-15.8,35.2-35.2,35.2H35.2 C15.8,630.6,0,614.8,0,595.4V35.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.6,113.6c4.3,4.4,10.3,16.6,0,29.8 M895.7,104.4c6.4,8.1,15.4,29.1,0,48.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M911.8,95.7c7.8,11.2,18.7,39.9,0,65.6 M928.7,87c9.3,14.4,22.4,51.1,0,83"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 764.8,
    cy: 128.5,
    r: 32.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 808.5,
    cy: 128.5,
    r: 32.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M640.1,430.8H66.8c-5.6,0-10.2-4.6-10.2-10.2l0,0c0-5.6,4.6-10.2,10.2-10.2h573.3c5.6,0,10.2,4.6,10.2,10.2l0,0 C650.3,426.3,645.7,430.8,640.1,430.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M381.4,494.8H66.8c-5.6,0-10.2-4.6-10.2-10.2l0,0c0-5.6,4.6-10.2,10.2-10.2h314.6c5.6,0,10.2,4.6,10.2,10.2l0,0 C391.6,490.3,387,494.8,381.4,494.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalCard);
export default __webpack_public_path__ + "static/media/physical_card.1f545745b9fa66f0c375b4f2c24d855b.svg";
export { ForwardRef as ReactComponent };